"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCustomFullStoryEvent = void 0;
const logging_1 = require("../logging");
const sendCustomFullStoryEvent = (eventName, eventData) => {
    const FS = window.FS;
    try {
        FS.event(eventName, eventData);
    }
    catch (e) {
        logging_1.logging.warn('Could not send custom event to fullStory', e);
    }
};
exports.sendCustomFullStoryEvent = sendCustomFullStoryEvent;
//# sourceMappingURL=fullStory.js.map